import apiClient, { type RequestConfig } from './client'

export type HotDocTag = 'HOT' | 'CRITICAL' | 'WATCH'

export interface HotDocPropagationBudget {
  allowed: boolean
  daily_spend_usd: number
  daily_limit_usd: number
  monthly_spend_usd: number
  monthly_limit_usd: number
  reason?: string | null
}

export interface HotDocPropagationEstimateResponse {
  tag: HotDocTag
  candidate_count: number
  estimated_cost_usd: number
  cost_range_low_usd: number
  cost_range_high_usd: number
  budget: HotDocPropagationBudget
  sample_candidate_ids: string[]
}

export interface HotDocPropagationExecuteResponse extends HotDocPropagationEstimateResponse {
  run_id: string
  status: string
}

export interface HotDocPropagationRunSummary {
  run_id: string
  tag: HotDocTag
  created_at: string
  considered_count: number
  propagated_count: number
  upgraded_count: number
  actual_cost_usd: number
  status: 'enqueued' | 'completed' | 'blocked_budget' | 'failed' | string
  status_reason?: string | null
}

export interface HotDocPropagationRunsResponse {
  runs: HotDocPropagationRunSummary[]
}

export const hotDocPropagationApi = {
  async estimate(
    matterId: string,
    documentId: string,
    tag: HotDocTag,
    config?: RequestConfig
  ): Promise<HotDocPropagationEstimateResponse> {
    const { data } = await apiClient.post<HotDocPropagationEstimateResponse>(
      `/matters/${matterId}/documents/${documentId}/hot-doc-propagation/estimate`,
      { tag },
      config
    )
    return data
  },

  async execute(
    matterId: string,
    documentId: string,
    tag: HotDocTag,
    config?: RequestConfig
  ): Promise<HotDocPropagationExecuteResponse> {
    const { data } = await apiClient.post<HotDocPropagationExecuteResponse>(
      `/matters/${matterId}/documents/${documentId}/hot-doc-propagation`,
      { tag, confirmed: true },
      config
    )
    return data
  },

  async listRuns(
    matterId: string,
    documentId: string,
    config?: RequestConfig
  ): Promise<HotDocPropagationRunsResponse> {
    const { data } = await apiClient.get<HotDocPropagationRunsResponse>(
      `/matters/${matterId}/documents/${documentId}/hot-doc-propagation/runs`,
      config
    )
    return data
  },
}
